//@ts-nocheck
import getDirection from 'direction'
import { Editor, Element, Node } from 'slate'
import { Registry } from '@react-registry'
import { ElementWithType } from '../../../../../../utils/types'
import { JsonNode } from '../../../utils/types'
import { getCurrentIndentLevel } from '../indentation/utils'
import { setTextDirectionStyle } from './utils'

/**
 * Syncs JSON attrs (dir + style) with Unicode RTL content during Slate normalization
 * instead of during React render (prevents path/descent errors when normalization
 * merges nodes concurrently with render-time Transforms).
 */
export const withTextDirection = (editor) => {
  const { normalizeNode } = editor

  editor.normalizeNode = (entry) => {
    try {
      const [node, path] = entry

      if (
        Element.isElement(node) &&
        node.type !== 'doc' &&
        !editor.isInline(node) &&
        path.length > 0
      ) {
        if (getCurrentIndentLevel(node as ElementWithType) > 0) {
          return normalizeNode(entry)
        }

        const nodeText = Node.string(node)
        if (getDirection(nodeText) !== 'rtl') {
          return normalizeNode(entry)
        }

        const attrs = node.attrs || {}
        if (attrs.dir === 'rtl' && attrs.style?.direction === 'rtl') {
          return normalizeNode(entry)
        }

        setTextDirectionStyle(editor, node as JsonNode, path, {
          direction: 'rtl',
          'text-align': 'right',
        })
        return
      }
    } catch (error) {
      console.error(error)
      return normalizeNode(entry)
    }

    return normalizeNode(entry)
  }

  return editor
}

Registry.register(withTextDirection, {
  id: 'withTextDirection',
  registry: 'v2.plugin',
})
